import { styled } from '@mui/material/styles'
import { FC } from 'react'
import {
  Datagrid, DateField,
  FunctionField,
  List,
  ListProps, TextField,
  TextInput
} from 'react-admin'
import { useLocation } from 'react-router-dom'
import { ListActionsToolbar } from '../../components'
import { LocationCreateButton } from '../../components/buttons/LocationCreateButton'
import SamenwerkingStatusChip from '../../components/cards/SamenwerkingStatusChip'
import { Samenwerking } from '../../types/apiRequests'

// Om te filteren op zaaknummer moet je ?filter={"nummerBinnenSysteem":"1234"} gebruiken.
// Dit moet url encoded, dus: ?filter=%7B"nummerBinnenSysteem"%3A"1234"%7D

const collaborationsFilter = [
  <TextInput key='nummerBinnenSysteem' label="data.nummerBinnenSysteem" source="nummerBinnenSysteem" />,
]

const CollaborationsList: FC<ListProps> = (props) => {
  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)
  const filter = searchParams.get('filter')

  let nummerBinnenSysteem: string | undefined
  if (filter) {
    try {
      const parsed = JSON.parse(filter) as unknown as { nummerBinnenSysteem: string }
      nummerBinnenSysteem = parsed.nummerBinnenSysteem || ''
    } catch (e) {
      console.warn('Invalid filter JSON', e)
    }
  }

  const search = nummerBinnenSysteem
    ? `?filter=${encodeURIComponent(JSON.stringify({ nummerBinnenSysteem }))}`
    : undefined

  return (
    <StyledList
      {...props}
      exporter={false}
      sort={{ field: 'creatieDatumTijd', order: 'DESC' }}
      actions={
        <ListActionsToolbar i18n="resources.collaborations.list">
          <LocationCreateButton
            access={['labs:all']}
            resource="samenwerkingen"
            label="resources.collaborations.create"
            search={search}
          />
        </ListActionsToolbar>
      }
      filters={collaborationsFilter}
    >
      <Datagrid
        bulkActionButtons={false}
        rowClick="show"
      >
        <FunctionField
          source="inOrOut"
          label="data.inOrOut"
          sortable={false}
          render={(record: Samenwerking) => record.oin_number === record.aangemaaktDoor ? 'Uitgaand' : 'Inkomend'}
        />
        <TextField
          source="id"
          label="data.id"
          sortable={false}
        />
        <TextField
          source="titel"
          label="data.name"
        />
        <DateField
          source="creatieDatumTijd"
          label="data.startDate"
        />
        <TextField
          source="aangemaaktDoorNaam"
          label="data.aangemaaktDoor"
          sortable={false}
        />
        <TextField
          source="contactpersoonNaam"
          label="data.contactpersoonNaam"
          sortable={false}
        />
        <FunctionField
          source="status"
          label="data.status"
          render={(record: Samenwerking) => <SamenwerkingStatusChip status={record.status} />}
        />
      </Datagrid>
    </StyledList>
  )
}

const PREFIX = 'xxllncCollaborationsList'

const classes = {
  spacer: `${PREFIX}-spacer`,
}

const StyledList = styled(List)(({ theme }) => ({
  [`& .${classes.spacer}`]: {
    marginLeft: theme.spacing(1)
  },
}))

export default CollaborationsList
